import { BranchContactWorker } from 'types/branch_contact_worker'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'

const resource = 'branch_contact_workers'

export const requests = {
  fetchBranchContactWorkers: async (params?: { worker_id?: number }) => {
    return axiosForGigbaseBiz.get<DataResponse<BranchContactWorker[]>>(
      resource,
      {
        params,
      },
    )
  },
}
